module.exports = __webpack_public_path__ + "static/media/img2.d8912049.png";